export const quackChatSystemMessageTypes = [
  "WELCOME",
  "CLOSED_CHAT",
  "ESCALATING_TO_LIVE_AGENT",
  "ESCALATING_TO_LIVE_AGENT_USER_REQUESTED",
  "NO_LIVE_AGENTS_AVAILABLE",
  "ESCALATING_TO_TICKET",
  "ESCALATING_TO_TICKET_USER_REQUESTED",
  "CONNECTED_TO_LIVE_AGENT",
  "DONE_WAITING_TO_LIVE_AGENT",
  "LIVE_AGENT_BUSY_REMINDER",
  "EMAIL_REQUEST",
  "FIRST_MESSAGE_REQUEST_EMAIL",
  "THANK_YOU_FOR_EMAIL",
  "THANK_YOU_FOR_PATIENCE",
  "UNABLE_TO_ESCALATE",
  "CREATED_TICKET",
  "FILE_UPLOADED",
  "FOLLOW_UP_REMINDER",
  "FALLBACK_ERROR",
] as const;

export type QuackChatSystemMessageType =
  (typeof quackChatSystemMessageTypes)[number];

export const quackChatSystemMessageTypesMap: Record<
  QuackChatSystemMessageType,
  { title: string; description: string }
> = {
  WELCOME: {
    title: "👋 Thread Opening",
    description: "A new conversation starts",
  },
  CLOSED_CHAT: {
    title: "Thread Closing",
    description: "The conversation is ending",
  },
  ESCALATING_TO_LIVE_AGENT: {
    title: "Escalate to Live Agent",
    description: "The issue requires a live agent for resolution",
  },
  ESCALATING_TO_LIVE_AGENT_USER_REQUESTED: {
    title: "Escalate to Live Agent (User Requested)",
    description:
      "The issue requires a live agent for resolution, but the user has requested to be escalated",
  },
  NO_LIVE_AGENTS_AVAILABLE: {
    title: "No Live Agents Available",
    description: "No live agents are currently online",
  },
  ESCALATING_TO_TICKET: {
    title: "Escalate to Ticket",
    description:
      "The issue needs to be forwarded to the support team via a ticket",
  },
  ESCALATING_TO_TICKET_USER_REQUESTED: {
    title: "Escalate to Ticket (User Requested)",
    description:
      "The issue needs to be forwarded to the support team via a ticket, but the user has requested to be escalated",
  },
  CONNECTED_TO_LIVE_AGENT: {
    title: "Connected to Live Agent",
    description: "The user is successfully connected to a live agent",
  },
  DONE_WAITING_TO_LIVE_AGENT: {
    title: "Live Agent Busy",
    description:
      "All agents are currently busy, and the user's request is in queue",
  },
  LIVE_AGENT_BUSY_REMINDER: {
    title: "Live Agent Busy Reminder",
    description:
      "The user is being reminded that all agents are currently busy",
  },
  EMAIL_REQUEST: {
    title: "Email Request",
    description: "Request the user's email address for follow-up",
  },
  THANK_YOU_FOR_EMAIL: {
    title: "Email Received",
    description: "The user provided their email address",
  },
  THANK_YOU_FOR_PATIENCE: {
    title: "Patience Acknowledged",
    description: "The system acknowledges the user's patience",
  },
  UNABLE_TO_ESCALATE: {
    title: "Escalation Failed",
    description: "The system is unable to escalate the request",
  },
  CREATED_TICKET: {
    title: "Ticket Created",
    description: "A support ticket has been created for the issue",
  },
  FILE_UPLOADED: {
    title: "File Uploaded",
    description: "The user has uploaded a file",
  },
  FOLLOW_UP_REMINDER: {
    title: "Follow-up Reminder",
    description: "A reminder to follow up with the user",
  },
  FALLBACK_ERROR: {
    title: "System or Session Error (Fallback)",
    description:
      "Used when a conversation fails due to a system issue, platform outage, or session timeout. Displays this fallback message when the Chat AI Agent can't generate a response or continue the session.",
  },
  FIRST_MESSAGE_REQUEST_EMAIL: {
    title: "First Message Request Email",
    description:
      "The user provided their email address in the first message, and the system is requesting to be emailed",
  },
};
